export default "__VITE_ASSET___ho9qRY$T_Jz6gdXf7k7$A__";